import React, { Component } from "react";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AuthAction from "../../../Redux/AuthRedux";
import IdleTimer from "react-idle-timer";
import dashboardImage from "../../../assets/img/dashboards.png";

import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import user from "../../masterData/user/user/user";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

class DashboardDelivery extends Component {
  constructor() {
    super();
    this.state = {
      timeout: 1000 * 100 * 9,
      isTimedOut: false,

      //penambahan untuk message
      popupMessage: false,
      message: "",
    };
    this.idleTimer = null;
  }

  createSubMenu = (val, link, icon) => {
    return (
      <NavLink to={link}>
        <div
          className="content"
          style={{
            borderWidth: 2,
            borderColor: "#000000",
            backgroundColor: "#E74C3C",
            borderStyle: "solid",
            borderRadius: 5,
            width: 235,
            height: 235,
            justifyContent: "space-evenly",
          }}
        >
          <div
            className="list"
            style={{
              marginTop: "35%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#ffffff",

              alignContent: "center",
            }}
          >
            <div className="icn" style={{ marginRight: 10 }}>
              <i className={`${icon} fa-lg`}></i>
            </div>
            <div className="ttl">{val}</div>
            <div className="icn icn-right txt-site txt-right txt-12" />
          </div>
        </div>
      </NavLink>
    );
  };

  checkPermissionSubMenu = (valMenu, valSubmenu) => {
    //static response for the moment,
    //will be activated later when authorization is ready to use
    return true;
    for (let indexData in this.state.menuData) {
      let item = this.state.menuData[indexData];
      if (item.menuId === valMenu) {
        let listForm = item.listForm;
        for (let indexSubData in listForm) {
          let subItem = listForm[indexSubData];
          if (subItem.formId === valSubmenu) {
            return true;
          }
        }
        break;
      }
    }
    return false;
  };

  forceLogout = () => {
    localStorage.clear("name");
    localStorage.clear("token");
    localStorage.clear("persist:primary");
    this.props.authLogout();
  };

  componentDidMount() {}

  componentWillMount() {}

  // penambahan untuk message
  componentWillUnmount() {}

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }}></Redirect>;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  render() {
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(this.props.auth.user) || R.isNil(jwtToken))
      return <Redirect to={{ pathname: "/" }}></Redirect>;
    return (
      <div className="main-content" style={{ backgroundColor: "#ffffff" }}>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive.bind(this)}
          onIdle={this.onIdle.bind(this)}
          onAction={this.onAction.bind(this)}
          debounce={250}
          timeout={this.state.timeout}
        />

        <div>
          <div className="popup-title padding-15px">{"DASHBOARD DELIVERY"}</div>
          <img
            src={require("../../../assets/img/dasboardbank2.png")}
            // alt=""
            style={{ marginRight: 10 }}
          />
          <img
            src={require("../../../assets/img/dashboardbank1.png")}
            // alt=""
            style={{ marginRight: 10 }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
    sumApproval: () => dispatch(AuthAction.sumApproval()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardDelivery);
